import styled from "styled-components";
import Spring from "../../components/Spring";

export const StyledAboutUs = styled(Spring)`
    position: relative;
`;
